const UBER_DRIVER_ID = 1000262;

export const isUberDriver = (driverId: number | undefined): boolean => driverId === UBER_DRIVER_ID;
